<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import Translatable from '@src/mixins/translatable.js'

import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  mixins: [Translatable],
  props: {
    object: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      truncationLimit: 333,
      // truncationLimit: 290,
      swiperOptions: {
        allowTouchMove: true,
        navigation: {
          nextEl: '.right-tab-control',
          prevEl: '.left-tab-control',
        },
        pagination: {
          el: '.schedule-pagination',
          clickable: true,
          bulletClass: 'small-bullet',
          bulletActiveClass: 'small-bullet-active',
        },
      },
    }
  },
  computed: {
    tip() {
      // return this.getTranslatedContent('tips', this.object.content).join('<br>')
      return this.getTranslatedContent('tips', this.object.content).length
        ? this.getTranslatedContent('tips', this.object.content).join('<br>')
        : this.object.content.en.tips.join('<br>')
    },
    isSlider() {
      return this.tip.length >= this.truncationLimit
    },
  },
}
</script>

<template>
  <div class="tab-content">
    <h5>{{ getTranslatedContent('TABS_Tips') }}</h5>
    <Swiper :scrollbar="true" :modules="[Virtual]" :options="swiperOptions">
      <SwiperSlide
        v-for="(tip, index) in getTranslatedContent(
          'tips',this.object.content)"
        :key="index"
        class="tip-text"
      >
        <ul class="tips-list">
          <li>
            {{ tip }}
          </li>
        </ul>
        <div slot="scrollbar" class="swiper-scrollbar"></div>
      </SwiperSlide>

      <div slot="button-prev" class="left-tab-control"></div>
      <div slot="button-next" class="right-tab-control"></div>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

h5 {
  margin-top: 35px;
  margin-left: 32px;
  margin-bottom: 15px;

  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: #ffffff;
}
.tab-content {
  margin-top: 35px;
  .tips-list {
    margin-left: 48px;
    width: 284px;

    & li {
      font-family: Open Sans, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      margin-bottom: 9px;
      list-style-image: url('../../assets/icons/checkmark.svg');
      list-style-position: outside;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

// .tip-text {
//   margin-left: 31px;
//   margin-right: 31px;

//   font-family: Open Sans, sans-serif;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 14px;
//   line-height: 23px;
//   color: #FFFFFF;
// }

.swiper-slide {
  height: 248px;
}

.control-mixin {
  position: absolute;
  width: 30px;
  height: 30px;
  bottom: 24px;
  cursor: pointer;
  z-index: 100;

  &.swiper-button-disabled {
    display: none;
  }
}

.left-tab-control {
  @extend .control-mixin;
  left: 23px;
  background: url('../../assets/icons/left.svg');
}

.right-tab-control {
  @extend .control-mixin;
  right: 23px;
  background: url('../../assets/icons/right.svg');
}
</style>
